import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { Effects } from './store/effects';
import { SoilAnalysisModule } from '../soil-analysis/soil-analysis.module';
import { featureReducer } from './store/reducers/feature.reducer';
import { mapContextReducer } from './store/reducers/map-context.reducer';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    SoilAnalysisModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    AgrFormModule,
  ],
  providers: [
    provideEffects([Effects]),
    provideState('app-map-context', mapContextReducer),
    provideState('app-feature', featureReducer),
  ],
})
export class GeoModule {}
